document.addEventListener("DOMContentLoaded", function () {
  const container = document.getElementById("numbered-pagination");
  if (!container) return;

  const current = parseInt(container.dataset.current);
  const total = parseInt(container.dataset.total);
  const currentUrlRaw = container.dataset.currentUrl || "";
  const currentUrl = currentUrlRaw.replace(/\/$/, "");
  const baseUrl = currentUrl.replace(/\/page\/\d+$/, "");

  const leftArrowSVG = container.querySelector(
    "#pagination__arrow--left"
  ).innerHTML;
  const rightArrowSVG = container.querySelector(
    "#pagination__arrow--right"
  ).innerHTML;

  const paginationEl = document.createElement("ul");
  paginationEl.className = "pagination__list";

  function createPageLink(
    page,
    htmlContent,
    active = false,
    isArrow = false,
    arrowSide = ""
  ) {
    const li = document.createElement("li");
    const a = document.createElement("a");
    a.href = page === 1 ? `${baseUrl}/` : `${baseUrl}/page/${page}/`;

    if (isArrow) {
      a.innerHTML = htmlContent;
      a.classList.add("pagination__arrow");
      a.classList.add(`pagination__arrow--${arrowSide}`);
      a.classList.add("group");
    } else {
      a.textContent = htmlContent;
    }

    if (active) {
      a.classList.add("active");
      a.setAttribute("aria-current", "page");
      a.href = "#";
      a.tabIndex = -1;
    }

    li.appendChild(a);
    return li;
  }

  if (current > 1) {
    paginationEl.appendChild(
      createPageLink(current - 1, leftArrowSVG, false, true, "left")
    );
  }

  paginationEl.appendChild(createPageLink(1, "1", current === 1));

  if (current > 3) {
    const ellipsis = document.createElement("li");
    ellipsis.innerHTML = `<span class="pagination__ellipsis" aria-hidden="true">…</span>`;
    paginationEl.appendChild(ellipsis);
  }

  const start = Math.max(2, current - 1);
  const end = Math.min(total - 1, current + 1);
  for (let i = start; i <= end; i++) {
    paginationEl.appendChild(createPageLink(i, i.toString(), i === current));
  }

  if (current < total - 2) {
    const ellipsis = document.createElement("li");
    ellipsis.innerHTML = `<span class="pagination__ellipsis" aria-hidden="true">…</span>`;
    paginationEl.appendChild(ellipsis);
  }

  if (total > 1) {
    paginationEl.appendChild(
      createPageLink(total, total.toString(), current === total)
    );
  }

  if (current < total) {
    paginationEl.appendChild(
      createPageLink(current + 1, rightArrowSVG, false, true, "right")
    );
  }

  container.appendChild(paginationEl);
});
